export type TClientTokenCard = {
    id: string,
    buyerIdAdquirente: string,
    firstName: string,
    lastName: string
}

export const initialClientTokenCard: TClientTokenCard = {
    id: "",
    buyerIdAdquirente: "",
    firstName: "",
    lastName: ""
}